<template>
    <div>
        <application-filter :action="filterAction" ></application-filter>
        <div class="switch-div">
           برنامه های من
            <label class="switch m-0 mr-2 ml-2">
                <input id="application_checkbox" type="checkbox" @change="checkbox_changed">
                <span class="slider round"></span>
            </label>
            تمام برنامه ها
        </div>
        <div class="col-12" v-if="$can('change-settings', 'open-banking')">
            <div class="d-flex justify-content-end">
                <button type="button" :disabled="refresh_button_is_loading" @click="refreshCachedTokens()"
                        aria-hidden="true"
                        style="font-size: 1.6em; color: #0f9af0" :title="$t('application.refresh_cached_tokens')"
                >
                    <i v-if="!refresh_button_is_loading" class="flaticon-refresh" style="font-size: 1.6em; color: #0f9af0"></i>
                    <i v-else class="fas flaticon-refresh fa-spin" style="font-size: 1.6em; color: #0f9af0"></i>
                </button>
            </div>
        </div>
        <kt-datatable  v-bind="datatableProps" ref="datatable"></kt-datatable>
    </div>
</template>

<script>
import columns from './datatable/columns'
import {ApiUrl, openBankingService} from '@/common/api.service'
import { AuthorizationHeader } from '@/common/jwt.service'
import applicationActions from './datatable/applicationActions'
import applicationFilter from '../application-filter'
import $ from "jquery";

export default {

    components: {
        'application-filter': applicationFilter,
    },
    data() {
        return {
            query: {},
            refresh_button_is_loading : false,
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "manage_application_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('open-banking/application/admin/get'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: applicationActions
            }
        },
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        },
        checkbox_changed(e) {
            let checkbox = $('#application_checkbox')

            if (checkbox.is(":checked"))
                this.query.my_applications = 1
            else
                this.query.my_applications = 0

            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        },
        refreshCachedTokens() {
            this.refresh_button_is_loading = true;

            openBankingService.adminRefreshCashedTokens().then((response) => {
                this.toastr.success(response.data.message)
            }).catch((response) => {
                this.toastr.error(response.data.message)
            }).finally(() => {
                setTimeout(() => {
                    this.refresh_button_is_loading = false
                }, 2000)
            });
        },
    }
}
</script>

<style>

</style>